<template>
    <el-header height="60px">
      <div class="header-left">
        <i class="el-icon-s-unfold" @click="clickFold"></i>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item,key) in breadcrumb" :key="key">
                <template v-if="item.url">
                    <router-link :to="item.url">{{item.name}}</router-link>
                </template>
                <template v-else>
                    {{item.name}}
                </template>
            </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <ul class="header-operations">
<!--          <li><router-link to="/admin/multiple">站点列表</router-link></li>
          <el-divider direction="vertical"></el-divider>-->
            <li>{{user.phone_mob }}</li>
          <el-divider direction="vertical"></el-divider>
            <li><span class="header-lang" @click="logout">退出</span></li>
        </ul>
    </el-header>

</template>

<script>
    import Cookies from 'js-cookie'
    import Vue from "vue";
    export default {
        name: "my-header",
        props:{
            breadcrumb:Array
        },
        data() {
            return {
                userId:0,
                user:{},
              isFold:false
            }
        },
        created() {

                this.userId = Cookies.get('user_id');
                this.$http.get('/v1/user/view',{params:{userId:this.userId}}).then((res)=>{
                    this.user = res.data;
                })

            /*this.breadcrumbData = this.$store.state.breadcrumb
            if (!this.breadcrumbData) {
                this.breadcrumbData = JSON.parse(sessionStorage.getItem('breadcrumb'))
                console.log(this.breadcrumbData)
            }*/
        },
        methods: {
            logout() {
                var _this = this;
                Cookies.remove('user_id',{domain:this.cookieDomain});
                Cookies.remove('access_token',{domain:this.cookieDomain});
                Cookies.remove('storeId',{domain:this.cookieDomain});
                /*this.$http.get(this.pcDomainUrl+'/?app=member&act=logout&ajax=1').then((res) => {
                    if (res.data.errcode == 0){
                        location.href = _this.pcLoginUrl;
                    }else {
                        location.href = _this.pcLoginUrl;
                    }
                });*/
              //location.href = Vue.prototype.loginDomain + '/#/admin/login?redirectUrl=' + encodeURIComponent(location.href)
              this.$router.push('/admin/login')
            },
          clickFold(){
            if (this.isFold){
              this.isFold = false;
              this.$emit('showLeftBar',false)
            }else {
              this.isFold = true;
              this.$emit('showLeftBar',true)
            }

          }
        }
    }
</script>

<style scoped>
.el-header {
  background: #fff;
  color: #666;
  line-height: 60px;
  border-bottom: 1px solid #ececec;
  padding: 0 10px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.header-operations {
  padding: 0;
  margin: 0;
  width: 50%;
  text-align: right;
}

.header-operations li {
  line-height: 60px;
  color: #666;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
}

.el-breadcrumb {
  margin: 0 0 0 10px;
  line-height: 60px;
  height: 60px;
  overflow: hidden;
}
.header-left{
  display: flex;
  align-items: center;
  width: 50%;
}
.el-icon-s-unfold{
  font-size: 18px;
}
</style>
